import React from 'react'
import get from 'lodash/get'
import moment from '../../../../lib/moment.js'
import { TabPane } from 'reactstrap'
import styled from 'styled-components'
import { StickyContainer, Sticky } from 'react-sticky'
import { Searchbar } from '../../search-bar'
import { CategoryButton } from './category-button'
import { HourRow } from './hour-row'
import { DataRow } from './data-row'
import { StatusRow } from './status-row'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'
import { Leave } from '../../form/show-leave'
import { Compensate } from '../../form/show-compensate'
import { Holiday } from '../../form/show-holiday'

export const TimesheetByProjects = class extends React.Component {
  state={ filterButton: 1, searchTimesheet: '' }

  clickFilterButton = (filterButton) => {
    this.setState({ filterButton })
  }

  showRequestDetail = (dataType, data) => {
    if (dataType === CONSTANTS.HOLIDAY || dataType === CONSTANTS.COMPENSATE) {
      this.setState({ dataType, data: this.changeDataFormat(dataType, data) })
    } else {
      this.setState({ dataType: CONSTANTS.LEAVE, data: this.changeDataFormat(dataType, data) })
    }
  }

  changeDataFormat = (dataType, data) => {
    switch (dataType) {
      case CONSTANTS.HOLIDAY: {
        const holiday = {}
        holiday.holiday_name = get(data, 'description')
        return holiday
      }
      case CONSTANTS.COMPENSATE: {
        const users = get(this.props, 'timesheets.users', [])
        const projects = get(this.props, 'timesheets.projects', [])
        const compensates = []

        data.map(d => {
          const compensate = {}
          const user = timesheetHelper.findUserData(get(d, 'user_id'), users)
          const approver = timesheetHelper.findUserData(get(d, 'approver_id'), users)
          const project = timesheetHelper.findUserData(get(d, 'project_id'), projects)
          compensate.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          compensate.project = project ? `${project.project_code} - ${project.name}` : '-'
          compensate.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          compensate.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          compensate.working_time = get(d, 'compensate_time')
          compensate.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          compensate.status = get(d, 'status')
          compensate.remark_request_user = get(d, 'remark_request_user')
          compensate.remark_approver = get(d, 'remark_approver')
          compensate.remark_cancel = get(d, 'remark_cancel')
          compensates.push(compensate)
          return d
        })
        return compensates
      }
      default: {
        const users = get(this.props, 'timesheets.users', [])
        const leaveTypes = get(this.props, 'leaveTypes', [])
        const leaves = []

        data.map(d => {
          const leave = {}
          const user = timesheetHelper.findUserData(get(d, 'user_id'), users)
          const approver = timesheetHelper.findUserData(get(d, 'approver_id'), users)
          const leave_type = timesheetHelper.findUserData(get(d, 'leave_type_id'), leaveTypes)

          leave.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          leave.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          leave.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          leave.leave_type = get(leave_type, 'name')
          leave.leave_time = get(d, 'leave_time')
          leave.created = moment(get(d, 'created')).format('DD/MM/YYYY')
          leave.days = get(d, 'days')
          leave.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          leave.status = get(d, 'status')
          leave.attachment_url = get(d, 'attachment_url')
          leave.remark_request_user = get(d, 'remark_request_user')
          leave.remark_approver = get(d, 'remark_approver')
          leave.remark_hr = get(d, 'remark_hr')
          leave.remark_cancel = get(d, 'remark_cancel')
          leaves.push(leave)
          return d
        })
        return leaves
      }
    }
  }

  handleClickCell = (dataType, data) => {
    this.setState({ showDetail: !this.state.showDetail })
    if (!this.state.showDetail) {
      this.showRequestDetail(dataType, data)
    } else {
      this.setState({ dataType: null, data: {} })
    }
  }

  render() {
    return (
      <TabPane tabId={ 2 }>
        <Content>
          <Leave
            showDetail={ this.state.dataType === CONSTANTS.LEAVE }
            handleDetail={ this.handleClickCell }
            data={ this.state.data }
          />
          <Compensate
            showDetail={ this.state.dataType === CONSTANTS.COMPENSATE }
            handleDetail={ this.handleClickCell }
            data={ this.state.data }
          />
          <Holiday
            showDetail={ this.state.dataType === CONSTANTS.HOLIDAY }
            handleDetail={ this.handleClickCell }
            { ...this.state.data }
          />
          <StickyContainer className="container relative">
            <CategoryButton
              { ...this.props }
              { ...this.state }
              clickFilterButton={ this.clickFilterButton }
              filterButton={ this.state.filterButton }
            />
            <div
              className="gap tall"
            >
              <Sticky relative={ true }>
                {({ style }) => (
                  <Div style={ style } >
                    <Searchbar
                      { ...this.props }
                      searchTimesheet={ this.state.searchTimesheet }
                      handleChangeSearch={ (e) => this.setState({ searchTimesheet: e }) }
                    />
                  </Div>
                )}
              </Sticky>
              <HourRow { ...this.props } />
              <DataRow
                { ...this.props }
                { ...this.state }
                handleClickCell={ this.handleClickCell }
              />
              <StatusRow />
            </div>
          </StickyContainer>
        </Content>
      </TabPane>

    )
  }
}

const Content = styled.div`
  height: calc(100vh - 120px);
  overflow-y: scroll;
  .container {
    height: calc(100vh - 125px);
    background: #EEEEEE;
    max-width: 100% ;
  }
  .gap.tall {
    height: 60%;
  }
  .container.relative {
    overflow-y: auto;
    margin: 0px !important;
    padding: 0px !important;
  }
`
const Div = styled.div`
  height: 40px;
  top: 120px !important;
  z-index: 999 !important;
  background: #EEEEEE;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-by-project/index.js